import { render, staticRenderFns } from "./accredAgree.vue?vue&type=template&id=508ba9ae&scoped=true&"
import script from "./accredAgree.vue?vue&type=script&lang=js&"
export * from "./accredAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ba9ae",
  null
  
)

export default component.exports